import { render, staticRenderFns } from "./ActionOriginShoot.vue?vue&type=template&id=5a55bf32"
import script from "./ActionOriginShoot.vue?vue&type=script&lang=js"
export * from "./ActionOriginShoot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports